module.exports = __webpack_public_path__ + "3baee93d9d047adbb294ba76d762c385.svg";